import * as Three from 'three';
import { Entity } from '../../engine/Entity';

export function replaceObjectByEntity(object: Three.Object3D, entity: Entity) {
  entity.copy(object as Entity, false);
  object.parent?.add(entity);
  object.removeFromParent();
  entity.attach(object);
}
